const HotStock = () =>
  import('@/views/main/helper/hotStock/HotStock.vue')
export default {
  path: '/main/helper/hotStock',
  name: 'HotStock',
  component: HotStock,
  children: []
}
